module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/list-layout/list-layout.component.scss
// module id = ./src/app/components/list-layout/list-layout.component.scss
// module chunks = main